<template>
    <FullContainer>
        <div class="card-header">
            <slot name="header">
            </slot>
        </div>
        <div class="card-container">
            <slot name="cards">
            </slot>
        </div>
    </FullContainer>
</template>

<script setup>
</script>

<style lang="scss">
@use "./index.scss";
</style>
